import React, { useEffect, useState, useCallback } from "react";
import HeaderMenu from "../Header/HeaderMenu";
import CreateSalesAgentDialog from "./CreateSalesAgentDialog";
import axiosApi from "../Utils/axiosApi";
import checkPermission from '../Utils/checkPermission';
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {
  Paper,
  Typography,
  Button,
  TextField,
  MenuItem,
  Select,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Chip,Pagination, Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText, FormControl,
  InputLabel,
  DialogActions,
} from "@mui/material";


const SalesTrackerPro = ({ location }) => {
  const [statusFilter, setStatusFilter] = useState("All");
  const [searchName, setSearchName] = useState("");
  const [properties, setProperties] = useState([]);

  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
const [pageNo, setPageNo] = useState(1);
const [pageSize, setPageSize] = useState(10);
const [totalPages, setTotalPages] = useState(0);

const [confirmWhatsappOpen, setConfirmWhatsappOpen] = useState(false);
const [selectedLead, setSelectedLead] = useState(null);
const [countryId, setCountryId] = useState("");
const [stateId, setStateId] = useState("");
const [districtId, setDistrictId] = useState("");
const [cityId, setCityId] = useState("");

const [countries, setCountries] = useState([]);
const [states, setStates] = useState([]);
const [districts, setDistricts] = useState([]);
const [cities, setCities] = useState([]);

  const emptyForm = {
    id: null,
    propertyName: "",
  propertyType: "Hostel",
  ownerName: "",
  phone: "",

  countryId: "",
  stateId: "",
  districtId: "",
  cityId: "",

  priority: "Medium",
  status: "New Lead",
  remarks: "",

  contactedByUserId: "",
  contactedByUserName: "",

  demoCompletedByUserId: "",
  demoCompletedByUserName: "",

  registeredByUserId: "",
  registeredByUserName: "",
  whatsappStatus: "NOT_SENT",
  whatsappSentDate: null,
  whatsappSentByUserId: "",
 whatsappSentByUserName: "",
 whatsappResponseStatus: "",
  };

  const [formData, setFormData] = useState(emptyForm);

  // =========================
  // LOAD API (FIXED)
  // =========================
const loadProperties = useCallback(async () => {
  try {
    const res = await axiosApi.post(
      "/crmPropertyLead/getCrmPropertyLead",
     {
    propertyName: searchName,
    status: statusFilter === "All" ? null : statusFilter,

    countryIds: countryId ? [countryId] : [],
    stateIds: stateId ? [stateId] : [],
    districtIds: districtId ? [districtId] : [],
    cityIds: cityId ? [cityId] : [],

    pageNo,
    pageSize,
}
    );

    setProperties(res.data?.crmPropertyLeadDTOs || []);

    setTotalPages(res.data?.totalPages || 0);

    if ((res.data?.totalPages || 0) === 0) {
      setPageNo(1);
    }
  } catch (err) {
    console.error(err);
  }
}, [
  searchName,
  statusFilter,
  countryId,
  stateId,
  districtId,
  cityId,
  pageNo,
  pageSize,
]);


useEffect(() => {
  loadProperties();
}, [loadProperties]);

useEffect(() => {
  axiosApi.post("/country/getCountry", {}).then((res) => {
    const data = Array.isArray(res.data)
      ? res.data
      : res.data.countries || [];

    setCountries(data);
  });
}, []);



useEffect(() => {
  if (!countryId) {
    setStates([]);
    setStateId("");
    return;
  }

  axiosApi
    .post("/state/getState", {
      countryIds: [countryId],
    })
    .then((res) => {
      const data = Array.isArray(res.data)
        ? res.data
        : res.data.states || [];

      setStates(data);
    });
}, [countryId]);


useEffect(() => {
  if (!stateId) {
    setDistricts([]);
    setDistrictId("");
    return;
  }

  axiosApi
    .post("/district/getDistrict", {
      stateIds: [stateId],
    })
    .then((res) => {
      const data = Array.isArray(res.data)
        ? res.data
        : res.data.districts || [];

      setDistricts(data);
    });
}, [stateId]);

useEffect(() => {
  if (!districtId) {
    setCities([]);
    setCityId("");
    return;
  }

  axiosApi
    .post("/city/getCity", {
      districtIds: [districtId],
    })
    .then((res) => {
      const data = Array.isArray(res.data)
        ? res.data
        : res.data.cities || [];

      setCities(data);
    });
}, [districtId]);
  // =========================
  // SEARCH
  // =========================
const handleSearch = () => {
  setPageNo(1);
  loadProperties();
};

const handleReset = () => {
  setSearchName("");
  setStatusFilter("All");

  setCountryId("");
  setStateId("");
  setDistrictId("");
  setCityId("");

  setPageNo(1);
};

  // =========================
  // CREATE
  // =========================
  const addProperty = async () => {
    try {
      await axiosApi.post("/crmPropertyLead/createCrmPropertyLead", {
        crmPropertyLeadDTO: formData,
      });

      setOpenAdd(false);
      setFormData(emptyForm);
      loadProperties();
    } catch (err) {
      console.error("Create failed", err);
    }
  };

  // =========================
  // UPDATE
  // =========================
  const updateProperty = async () => {
    try {
      await axiosApi.post("/crmPropertyLead/updateCrmPropertyLead", {
        crmPropertyLeadDTO: formData,
      });

      setOpenEdit(false);
      setFormData(emptyForm);
      loadProperties();
    } catch (err) {
      console.error("Update failed", err);
    }
  };

  // =========================
  // DELETE
  // =========================
  const deleteProperty = async (id) => {
    try {
      await axiosApi.post("/crmPropertyLead/deleteCrmPropertyLead", { id });
      loadProperties();
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  // =========================
  // ACTIONS
  // =========================


// ================================
// LEAD SCORE
// ================================
const getNextAction = (lead) => {
  const today = new Date();

  const getDays = (date) => {
    if (!date) return 0;

    return Math.floor(
      (today - new Date(date)) / (1000 * 60 * 60 * 24)
    );
  };

  // =====================================
  // Closed Leads
  // =====================================
  switch (lead.status) {
    case "Registered":
      return "✅ Onboard Property";

    case "Rejected":
      return "❌ Closed";

    case "Lost":
      return "📦 Archive Lead";

    default:
      break;
  }

  // =====================================
  // WhatsApp Flow (ONLY for New Lead)
  // =====================================
  if (lead.status === "New Lead") {
    // WhatsApp not sent
    if (lead.whatsappStatus !== "SENT") {
      return "💬 Send First WhatsApp";
    }

    const days = getDays(lead.whatsappSentDate);

    switch (lead.whatsappResponseStatus) {
      case "ACCEPTED":
        return "🚨 Call Immediately";

      case "REJECTED":
        return "📞 Call & Explain Benefits";

      case "PENDING":
        if (days < 3)
          return "⏳ Await Customer Decision";

        return "📞 Follow-up Call";

      case "NO_RESPONSE":
      case "":
      case null:
      case undefined:
      default:
        if (days < 3)
          return "⏳ Await WhatsApp Response";

        if (days < 7)
          return "📲 Send WhatsApp Reminder";

        return "📞 Call Lead";
    }
  }

  // =====================================
  // CRM Workflow
  // (Ignore WhatsApp after Contacted)
  // =====================================
  switch (lead.status) {
    case "Contacted":
      return "📅 Schedule Demo";

    case "Interested":
      return "📅 Schedule Demo";

    case "Demo Scheduled":
      return "🎥 Conduct Demo";

    case "Demo Completed":
      return "📄 Send Proposal";

    case "Proposal Sent":
      return "💰 Discuss Pricing";

    case "Negotiation":
      return "🤝 Close Deal";

    case "Follow Up":
      return "📞 Follow Up";

    default:
      return "-";
  }
};


  const callOwner = (phone) => window.open(`tel:${phone}`);
const getWhatsappMessage = (p) => {
  switch (p.propertyType) {
    case "Hostel":
      return `Hi ${p.ownerName},

🏨 Is ${p.propertyName} still managing bookings, room allocation, student records, and fee collection manually?

HostelandPG helps hostels automate daily operations and increase occupancy through a single platform.

✅ Online Guest Bookings
✅ Own Hostel Booking Website
✅ Room & Bed Allocation
✅ Student/Guest Management
✅ Fee Collection & Billing
✅ Attendance Tracking
✅ Expense Management
✅ Occupancy Reports
✅ WhatsApp Notifications

🌐 Get direct bookings and showcase your property on:
www.hostelandpg.com

🎉 Special Offer for New Partner Properties

✅ FREE Property Listing
✅ FREE Live Demo
✅ FREE Setup Assistance
✅ No Technical Knowledge Required

Benefits:
📈 Increase Occupancy
💰 Improve Revenue
⏱️ Save Time & Reduce Manual Work

Interested in getting more bookings?

Reply with:
1️⃣ Demo
2️⃣ Call Me
3️⃣ Send Details

Team HostelandPG
www.hostelandpg.com`;

    case "Hotel":
      return `Hi ${p.ownerName},

🏨 Looking to increase bookings and simplify operations at ${p.propertyName}?

HostelandPG provides a complete Hotel Management & Online Booking Platform.

✅ Direct Online Bookings
✅ Own Hotel Booking Website
✅ Reservation Management
✅ Guest Check-In / Check-Out
✅ Billing & Invoicing
✅ Expense Tracking
✅ Staff Management
✅ Revenue & Occupancy Reports
✅ WhatsApp Notifications

🌐 Get listed and receive bookings through:
www.hostelandpg.com

🎉 Special Offer for New Partner Properties

✅ FREE Property Listing
✅ FREE Live Demo
✅ FREE Setup Assistance
✅ No Technical Knowledge Required

Benefits:
📈 More Occupancy
💰 More Revenue
⏱️ Less Manual Work

Interested in getting more bookings?

Reply with:
1️⃣ Demo
2️⃣ Call Me
3️⃣ Send Details

Team HostelandPG
www.hostelandpg.com`;

    case "Home Stay":
      return `Hi ${p.ownerName},

🏡 Want more bookings for ${p.propertyName} while reducing administrative work?

HostelandPG helps homestay owners manage bookings and daily operations effortlessly.

✅ Online Booking System
✅ Own Booking Website
✅ Guest Records
✅ Billing & Payments
✅ Expense Tracking
✅ Occupancy Reports
✅ Property Performance Insights
✅ WhatsApp Notifications

🌐 Get listed and start receiving booking enquiries:
www.hostelandpg.com

🎉 Special Offer for New Partner Properties

✅ FREE Property Listing
✅ FREE Live Demo
✅ FREE Setup Assistance
✅ No Technical Knowledge Required

Benefits:
📈 More Visibility
💰 More Direct Bookings
⏱️ Less Administrative Work

Interested in getting more bookings?

Reply with:
1️⃣ Demo
2️⃣ Call Me
3️⃣ Send Details

Team HostelandPG
www.hostelandpg.com`;

    default:
      return `Hi ${p.ownerName},

🚀 Grow bookings and simplify property operations with HostelandPG.

We provide a complete Property Management & Online Booking Platform.

✅ Online Booking Platform
✅ Property Management Software
✅ Guest Management
✅ Billing & Payments
✅ Expense Tracking
✅ Reports & Analytics
✅ WhatsApp Notifications

🌐 Learn more:
www.hostelandpg.com

🎉 Special Offer for New Partner Properties

✅ FREE Property Listing
✅ FREE Live Demo
✅ FREE Setup Assistance
✅ No Technical Knowledge Required

Benefits:
📈 More Bookings
💰 Better Revenue
⏱️ Less Manual Work

Interested in getting more bookings?

Reply with:
1️⃣ Demo
2️⃣ Call Me
3️⃣ Send Details

Team HostelandPG
www.hostelandpg.com`;
  }
};
const whatsappOwner = async () => {
  if (!selectedLead) return;

  try {
    const msg = getWhatsappMessage(selectedLead);

    window.open(
      `https://wa.me/${selectedLead.phone}?text=${encodeURIComponent(msg)}`,
      "_blank"
    );

    await axiosApi.post(
      "/crmPropertyLead/updateWhatsappStatus",
      {
        leadId: selectedLead.id
      }
    );

    setConfirmWhatsappOpen(false);
    setSelectedLead(null);

    loadProperties();
  } catch (error) {
    console.error("WhatsApp status update failed", error);
  }
};

  return (
    <>
      {!location?.state?.disableHeader && <HeaderMenu />}

      <Paper sx={{ p: 3, mt: 3, borderRadius: 4 }}>
        <Typography variant="h4">CRM Dashboard</Typography>
<Grid container spacing={2} mt={2} alignItems="center">

  <Grid item xs={12} md={3}>
    <TextField
      fullWidth
      size="small"
      label="Search Property"
      value={searchName}
      onChange={(e) => setSearchName(e.target.value)}
    />
  </Grid>

  <Grid item xs={12} md={2}>
    <FormControl fullWidth size="small">
      <InputLabel>Status</InputLabel>

      <Select
        value={statusFilter}
        label="Status"
        onChange={(e) => setStatusFilter(e.target.value)}
      >
        <MenuItem value="All">All</MenuItem>
        <MenuItem value="New Lead">New Lead</MenuItem>
        <MenuItem value="Contacted">Contacted</MenuItem>
        <MenuItem value="Interested">Interested</MenuItem>
        <MenuItem value="Demo Scheduled">Demo Scheduled</MenuItem>
        <MenuItem value="Demo Completed">Demo Completed</MenuItem>
        <MenuItem value="Proposal Sent">Proposal Sent</MenuItem>
        <MenuItem value="Negotiation">Negotiation</MenuItem>
        <MenuItem value="Follow Up">Follow Up</MenuItem>
        <MenuItem value="Registered">Registered</MenuItem>
        <MenuItem value="Rejected">Rejected</MenuItem>
        <MenuItem value="Lost">Lost</MenuItem>
      </Select>
    </FormControl>
  </Grid>

  <Grid item xs={12} md={2}>
    <FormControl fullWidth size="small">
      <InputLabel>Country</InputLabel>

      <Select
        value={countryId}
        label="Country"
       onChange={(e) => {
    setCountryId(e.target.value);
    setStateId("");
    setDistrictId("");
    setCityId("");
}}
      >
        <MenuItem value="">All</MenuItem>

        {countries.map((c) => (
          <MenuItem key={c.id} value={c.id}>
            {c.countryName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>

  <Grid item xs={12} md={2}>
    <FormControl fullWidth size="small">
      <InputLabel>State</InputLabel>

      <Select
        value={stateId}
        label="State"
        onChange={(e) => {
    setStateId(e.target.value);
    setDistrictId("");
    setCityId("");
}}
      >
        <MenuItem value="">All</MenuItem>

        {states.map((s) => (
          <MenuItem key={s.id} value={s.id}>
            {s.stateName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>


<Grid item xs={12} md={2}>
  <FormControl fullWidth size="small">
    <InputLabel>District</InputLabel>

    <Select
      value={districtId}
      label="District"
      onChange={(e) => {
        setDistrictId(e.target.value);
        setCityId("");
      }}
    >
      <MenuItem value="">All</MenuItem>

      {districts.map((d) => (
        <MenuItem key={d.id} value={d.id}>
          {d.districtName}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>
<Grid item xs={12} md={2}>
  <FormControl fullWidth size="small">
    <InputLabel>City</InputLabel>

    <Select
      value={cityId}
      label="City"
      onChange={(e) => setCityId(e.target.value)}
    >
      <MenuItem value="">All</MenuItem>

      {cities.map((c) => (
        <MenuItem key={c.id} value={c.id}>
          {c.cityName}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>
  <Grid item xs={6} md={1}>
    <Button
      fullWidth
      variant="contained"
      onClick={handleSearch}
    >
      Search
    </Button>
  </Grid>

  <Grid item xs={6} md={1}>
    <Button
      fullWidth
      variant="outlined"
      onClick={handleReset}
    >
      Reset
    </Button>
  </Grid>

  <Grid item xs={12} md={1}>
    <Button
      fullWidth
      color="success"
      variant="contained"
      disabled={!checkPermission("CRM", "Sales Agent", "CREATE")}
      onClick={() => {
        setFormData(emptyForm);
        setOpenAdd(true);
      }}
    >
      Add
    </Button>
  </Grid>

</Grid>

        {/* TABLE */}
        <TableContainer component={Paper} sx={{ mt: 3 }}>
          <Table size="small">
           <TableHead>
  <TableRow sx={{ background: "#f5f7ff" }}>
    <TableCell>Property</TableCell>
    <TableCell>Type</TableCell>
    <TableCell>Phone</TableCell>
    <TableCell>Country</TableCell>
    <TableCell>State</TableCell>
    <TableCell>City</TableCell>

    <TableCell>Contacted</TableCell>
    <TableCell>Demo</TableCell>
    <TableCell>Registered</TableCell>

    <TableCell>Priority</TableCell>
    <TableCell>Status</TableCell>
	<TableCell>WhatsApp</TableCell>
    <TableCell>Next Action</TableCell>
    <TableCell>Actions</TableCell>
  </TableRow>
</TableHead>

         <TableBody>
  {properties.map((p) => (
    <TableRow key={p.id}>
      <TableCell>{p.propertyName}</TableCell>
      <TableCell>{p.propertyType}</TableCell>
      <TableCell>{p.phone}</TableCell>
      <TableCell>{p.country || "-"}</TableCell>
      <TableCell>{p.state || "-"}</TableCell>
      <TableCell>{p.cityArea || "-"}</TableCell>

      <TableCell>{p.contactedByUserName || "-"}</TableCell>
      <TableCell>{p.demoCompletedByUserName || "-"}</TableCell>
      <TableCell>{p.registeredByUserName || "-"}</TableCell>

      <TableCell>
        <Chip label={p.priority} />
      </TableCell>

      <TableCell>
        <Chip label={p.status} />
      </TableCell>
<TableCell>
  <Chip
    label={
      p.whatsappStatus === "SENT"
        ? p.whatsappResponseStatus
          ? `SENT - ${p.whatsappResponseStatus.replace("_", " ")}`
          : "SENT"
        : "NOT SENT"
    }
    color={
      p.whatsappResponseStatus === "ACCEPTED"
        ? "success"
        : p.whatsappResponseStatus === "REJECTED"
        ? "error"
        : p.whatsappResponseStatus === "PENDING"
        ? "warning"
        : p.whatsappStatus === "SENT"
        ? "info"
        : "default"
    }
    size="small"
  />
</TableCell>
      <TableCell>
        <Chip
          label={getNextAction(p)}
          variant="outlined"
        />
      </TableCell>

      <TableCell
  align="center"
  sx={{
    whiteSpace: "nowrap",
    width: 1, // shrink to content
  }}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 0.5,
    }}
  >
   

  <Tooltip
  title={
    p.whatsappStatus === "SENT"
      ? `WhatsApp Sent${
          p.whatsappResponseStatus
            ? ` | Response: ${p.whatsappResponseStatus}`
            : ""
        }`
      : "Send WhatsApp"
  }
>
  <span>
    <IconButton
      disabled={p.whatsappStatus === "SENT"}
      sx={{
        p: 0.5,
        width: 40,
        height: 40,
      }}
      onClick={() => {
        setSelectedLead(p);
        setConfirmWhatsappOpen(true);
      }}
    >
      <WhatsAppIcon
        sx={{
          fontSize: 24,
          color:
            p.whatsappStatus === "SENT"
              ? "#25D366"
              : "#d32f2f",
        }}
      />
    </IconButton>
  </span>
</Tooltip>

    <Button
  size="small"
  sx={{
    minWidth: 50,
    px: 1,
  }}
  onClick={() => callOwner(p.phone)}
>
  Call
</Button>

<Button
  size="small"
  color="warning"
  sx={{
    minWidth: 50,
    px: 1,
  }}
  onClick={() => {
    setFormData(p);
    setOpenEdit(true);
  }}
>
  Edit
</Button>

<Button
  size="small" disabled={!checkPermission("CRM", "Sales Agent", "DELETE")}
  color="error"
  sx={{
    minWidth: 60,
    px: 1,
  }}
  onClick={() => deleteProperty(p.id)}
>
  Delete
</Button>
  </Box>
</TableCell>
    </TableRow>
  ))}
</TableBody>
          </Table>
        </TableContainer>
<Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mt: 2,
    flexWrap: "wrap",
    gap: 2,
  }}
>
 <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mt: 2,
    flexWrap: "wrap",
    gap: 2,
  }}
>
  <Pagination
    count={Math.max(totalPages, 1)}
    page={pageNo}
    onChange={(e, value) => setPageNo(value)}
    color="primary"
    shape="rounded"
  />

  <div>
    <label style={{ marginRight: "8px" }}>
      Rows per page:
    </label>

    <select
      value={pageSize}
      onChange={(e) => {
        setPageSize(Number(e.target.value));
        setPageNo(1);
      }}
    >
      {[5, 10, 15, 20].map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  </div>
</Box>

 
</Box>
        <CreateSalesAgentDialog
          open={openAdd || openEdit}
          onClose={() => {
            setOpenAdd(false);
            setOpenEdit(false);
          }}
          formData={formData}
          setFormData={setFormData}
          onSubmit={openEdit ? updateProperty : addProperty}
          isEdit={openEdit}
        />
		<Dialog
  open={confirmWhatsappOpen}
  onClose={() => setConfirmWhatsappOpen(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>
    Confirm WhatsApp Message
  </DialogTitle>

  <DialogContent>
    <DialogContentText>
      Are you sure you want to send a WhatsApp marketing message to:
      <br />
      <br />
      <strong>{selectedLead?.ownerName}</strong>
      <br />
      {selectedLead?.propertyName}
      <br />
      {selectedLead?.phone}
    </DialogContentText>
  </DialogContent>

  <DialogActions>
    <Button
      onClick={() => {
        setConfirmWhatsappOpen(false);
        setSelectedLead(null);
      }}
    >
      Cancel
    </Button>

    <Button
      variant="contained"
      color="success"
      onClick={whatsappOwner}
    >
      Send WhatsApp
    </Button>
  </DialogActions>
</Dialog>
		
      </Paper>
    </>
  );
};

export default SalesTrackerPro;